import { Component, OnInit, Input } from '@angular/core';
import { SchemaField, Document } from '../../../../core/store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'app-url-column',
    templateUrl: './url-column.component.html',
    styleUrls: ['./url-column.component.scss'],
    standalone: false
})
export class UrlColumnComponent implements OnInit, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  constructor() {}

  ngOnInit(): void {}

  get fieldValue(): string {
    return this.document?.[this.field.systemName];
  }
}
